import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  UserUpdateRequest,
  UserUpdateResponse,
  userUpdateResponseSchema,
} from '../../../common/validations'

import { patch } from 'api/apiClient'

export const useAPIUpdateUserDetails = (
  options?: UseMutationOptions<
    UserUpdateResponse,
    ErrorResponse,
    UserUpdateRequest
  >
) =>
  useMutation({
    mutationFn: (values) =>
      patch(API_ENDPOINTS.UPDATE_DETAILS, values, userUpdateResponseSchema),
    ...options,
  })
